var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"data-component-id":"RecruiterStatusRecommended"}},[_c('v-card-title',{staticClass:"text-h5"},[_vm._v(" Associer candidat à une offre ")]),(_vm.isLoading)?_c('v-progress-linear',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e(),_c('v-card-text',[_c('v-form',{model:{value:(_vm.isValidForm),callback:function ($$v) {_vm.isValidForm=$$v},expression:"isValidForm"}},[_vm._l((_vm.fields),function(field,fieldIndex){return [_c('div',{key:fieldIndex},[(field.name === 'entityUuid')?_c('PositionInput',{attrs:{"field":{
              ...field,
              disabled: _vm.isLoading
            },"classes":_vm.getInputClasses(field)},on:{"input":function($event){_vm.data.offerUuid = null;}},model:{value:(_vm.data[field.name]),callback:function ($$v) {_vm.$set(_vm.data, field.name, $$v)},expression:"data[field.name]"}}):(field.name === 'offerUuid')?_c('PositionInput',{attrs:{"view-only":!_vm.data.entityUuid,"field":{
              ...field,
              additionalFilters: [
                {
                  match: {
                    'entity.uuid.raw': _vm.data.entityUuid
                  }
                },
                {
                  match: {
                    status: 'published'
                  }
                },
                ...(_vm.data.offer?.uuid ? [{
                  bool: {
                    must_not: [
                      { term: { 'uuid.raw': _vm.data.offer.uuid } }
                    ]
                  }
                }] : [])
              ],
              disabled: _vm.isLoading
            },"classes":_vm.getInputClasses(field)},model:{value:(_vm.data[field.name]),callback:function ($$v) {_vm.$set(_vm.data, field.name, $$v)},expression:"data[field.name]"}}):_c('GenericField',{attrs:{"field":{
              ...field,
              disabled: _vm.isLoading
            }},model:{value:(_vm.data.message),callback:function ($$v) {_vm.$set(_vm.data, "message", $$v)},expression:"data.message"}})],1)]})],2)],1),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"text":""},on:{"click":_vm.handleDisagree}},[_vm._v(" Annuler ")]),_c('v-btn',{attrs:{"disabled":!_vm.isValidForm || _vm.isLoading,"color":"primary","text":""},on:{"click":_vm.handleAccept}},[_vm._v(" Accepter ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }